import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from 'react-admin';

/**
 * Tabs at the top of the Top-Ups admin pages.
 *
 * "Successful (Wallet Ledger)" → /app-topups (queries app_transactions with
 *   type=topup; only completed payments). This is the bookkeeping view —
 *   refunds, gateway-reference exports, etc.
 *
 * "All Attempts (Gateway Sessions)" → /app-topup-attempts (queries
 *   app_payment_sessions). Includes failed / cancelled / timed-out attempts
 *   with their gateway request/response/webhook payloads. This is the
 *   debugging view.
 */
interface Props {
    active: 'successful' | 'attempts';
}

export const TopUpViewToggle: React.FC<Props> = ({ active }) => {
    const navigate = useNavigate();
    const translate = useTranslate();
    const value = active === 'successful' ? 0 : 1;

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs
                value={value}
                onChange={(_e, v) => {
                    navigate(v === 0 ? '/app-topups' : '/app-topup-attempts');
                }}
                aria-label="top-up view toggle"
            >
                <Tab
                    label={translate('resources.app-topups.views.successful', {
                        _: 'Successful (Wallet Ledger)',
                    })}
                />
                <Tab
                    label={translate('resources.app-topups.views.attempts', {
                        _: 'All Attempts (Gateway Sessions)',
                    })}
                />
            </Tabs>
        </Box>
    );
};
